import { SelectBoxData } from './types'

export const getFilteredSelectBoxData = (data: SelectBoxData[], searchValue: string) => {
  return searchValue.length
    ? data.filter(item => item.label.toLowerCase().includes(searchValue.toLowerCase()))
    : data
}
